import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { PriorityFilter } from '../../shared/models/priorityFilter';
import { v_DispatchGrid2Bus } from '../../shared/models/v_DispatchGrid2Bus';
import { v_LocationDetailBus } from '../../shared/models/v_LocationDetailBus';
import { DispatchBoardPanels } from "../../shared/enums/DispatchBoardPanels";
import { DispatchBoardService } from '../../shared/services/dispatch-board.service';
import { CustomerService } from '../../shared/services/customer.service';
import { forkJoin, of, Subscription } from 'rxjs';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { DomSanitizer } from '@angular/platform-browser';
import { DispatchAssignmentBus } from '@app/cp/shared/models/DispatchAssignmentBus';

@Component({
    selector: 'cp-dispatch-calendar-obj',
    templateUrl: './dispatch-calendar-obj.component.html',
    styleUrls: ['./dispatch-calendar-obj.component.scss']
})
export class DispatchCalendarObjComponent implements OnInit {

    subscriptions: Subscription[] = [];
    hidePanel: boolean = false;
    notDropped: boolean = true;
    constructor(private svc_data: DispatchBoardService, private svc_cust: CustomerService, private sanitizer: DomSanitizer) {
        this.subscriptions.push(svc_data.dropLocation$.subscribe((location) => {

        }));
        this.subscriptions.push(svc_data.selectedDispatch$.subscribe((selection) => {

            this.showTooltip();
        }));
        this.subscriptions.push(svc_data.dispatchDragStart$.subscribe((dragging) => {
            if (this.tooltipDir) {
                this.tooltipDir.hide();
            }
        }));
        this.subscriptions.push(svc_data.dispatchDragDrop$.subscribe((dispatchId:any) => {
            if (dispatchId.dispatchId ==this.dispatch.dispatchId) {
                console.log('hide mea' + this.dispatch.dispatchNumber);
                this.notDropped = true;
            }
        }));
    }

    @Input() dispatch: v_DispatchGrid2Bus;
    @Input() assignment: DispatchAssignmentBus;
    @Input() priorityFilter: PriorityFilter;
    @Input() customerFilter: string;
    @Input() parentPanel: DispatchBoardPanels;
    @Input() selected: boolean = true;
    @Input() selectedDispatch: string;
    @Input() dragDisable: boolean = false;

    logo: any;
    locationDetails: v_LocationDetailBus;

    textColor: string;

    @Output() dispatchDrag = new EventEmitter<object>();
    @Output() moveDispatch = new EventEmitter<object>();
    @Output() assignDispatch = new EventEmitter<object>();
    @Output() unAssignDispatch = new EventEmitter<object>();
    @Output() viewDispatch = new EventEmitter<object>();

    dropSubscription: Subscription;
    eventZombie: any;

    ngOnInit() {

        this.priorityFilter = {
            Overtime: true,
            High: true,
            HotParts: true,
            Normal: true,
            Warranty: true,
            PM: true,
            Locked: true,
            SpecialEquipment: true,
        };
        this.calcLumen();
    }

    setpartpriority(level) {

        //let level = Math.floor( Math.random() * 3 - 1 + 1 ) + 1;
        let priorityClass = '';
        switch (level) {
            case "Blue":
                priorityClass = 'levelOne';

                break;
            case "Yellow":
                priorityClass = 'levelTwo';
                break;
            case "Red":
                priorityClass = 'levelThree';
                break;
        }
        return priorityClass;
    }

    ngOnDestroy() {
        this.subscriptions.forEach( subscription => subscription.unsubscribe() );
    }

    calcLumen() {
        if ( this.dispatch.visitCount && this.dispatch.visitCount > 0 ) {
            let r = parseInt( this.dispatch.boardColorHex.substr( 1, 2 ), 16 );
            let g = parseInt( this.dispatch.boardColorHex.substr( 3, 2 ), 16 );
            let b = parseInt( this.dispatch.boardColorHex.substr( 5, 2 ), 16 );
            let yiq = ((r*299)+(g*587)+(b*114))/1000;
            if (yiq >= 128){
                this.textColor = '';
            } else {
                this.textColor = 'white';
            }
        } else {
            this.textColor = '';
        }
    }

    public popupClass: string = 'cp-light-popup';
    isDragging: boolean = false;
    startPosition: any = { x: 0, y: 0 };

    menuItems: Array<any> = [{
            text: 'Change Status',
            icon: 'exchange',
            value: 1
        }, {
            text: 'Assign',
            icon: 'user-plus',
            value: 2
        }, {
            text: 'View Dispatch',
            icon: 'th',
            value: 3
        }, {
            text: 'Un-Assign',
            icon: 'user-plus',
            value: 4
        }
    ];

    setPriorityClass(priority) {
        let className = '';
        switch (priority) {
            case 'Overtime Approved':
                className = 'priority-overtime-approval';
                break;
            case 'High':
                className = 'priority-high';
                break;
            case 'HOT PARTS - ASAP':
                className = 'priority-hot-parts';
                break;
            case 'Normal':
                className = 'priority-normal';
                break;
            case 'Warranty (Hot)':
                className = 'priority-warranty';
                break;
            case 'PM':
                className = 'priority-pm';
                break;
            case 'LOCKED - SCHEDULED':
                className = 'priority-locked-scheduled';
                break;
            case 'Special Equipment':
                className = 'priority-special-equipment';
                break;
            default:
                className = 'priority-nopriority';
        }
        return className;
    }
    getDisplayBool() {
        let customerBool: boolean = true;
        if (this.customerFilter && this.customerFilter != '') {
            customerBool = this.customerFilter == this.dispatch.customerId ? true : false;
        }
        let priority = this.dispatch.priorityName;
        let displayBool = true;
        switch (priority) {
            case 'Overtime Approved':
                displayBool = this.priorityFilter.Overtime ? true : false;
                break;
            case 'High':
                displayBool = this.priorityFilter.High ? true : false;
                break;
            case 'HOT PARTS - ASAP':
                displayBool = this.priorityFilter.HotParts ? true : false;
                break;
            case 'Normal':
                displayBool = this.priorityFilter.Normal ? true : false;
                break;
            case 'Warranty (Hot)':
                displayBool = this.priorityFilter.Warranty ? true : false;
                break;
            case 'PM':
                displayBool = this.priorityFilter.PM ? true : false;
                break;
            case 'LOCKED - SCHEDULED':
                displayBool = this.priorityFilter.Locked ? true : false;
                break;
            case 'Special Equipment':
                displayBool = this.priorityFilter.SpecialEquipment ? true : false;
                break;
        }
        return displayBool && customerBool;
    }
    dragging(event: any, state: boolean) {
        //this.dropSubscription.unsubscribe();
        this.isDragging = state;
        if (state == false) {
            //this.dropSubscription = forkJoin(this.svc_data.dropLocation$, of(event)).subscribe((e) => {

            //});
            event.source.reset();
            this.eventZombie = event;
            this.dispatchDrag.emit({ dispatch: this.dispatch, dragState: false });
        } else {
            this.svc_data.setSelectedDispatch('');
            this.dispatchDrag.emit({ dispatch: this.dispatch, dragState: true });
        }
    }
    onMenuItemClick(e) {
        switch (e.value) {
            case 1:
                this.moveDispatch.emit(this.dispatch);
                break;
            case 2:
                this.assignDispatch.emit(this.dispatch);
                break;
            case 3:
                this.viewDispatch.emit(this.dispatch);
                break;
            case 4:
                this.unAssignDispatch.emit(this.dispatch);
                break;
        }
    }

    @ViewChild(TooltipDirective)
    public tooltipDir: TooltipDirective;

    public showTooltip(eventTarget?: any): void {
        if (this.selectedDispatch && this.dispatch && (this.selectedDispatch == this.dispatch.dispatchId && !eventTarget)) {
			this.tooltipDir.hide();
        } else if (eventTarget) {
            this.svc_cust.getLogo(this.dispatch.customerId).subscribe(blob => {
                this.logo = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
            });
            this.svc_cust.getLocationDetail(this.dispatch.locationId).subscribe(data => {
                this.locationDetails = data;
            });
			this.tooltipDir.show(eventTarget);
		}
    }
}

//.mergeMap((ev) => {
//    return Observable
//        .of(ev)
//        .delay(850)
//        .takeUntil(this._mouseLeaveStream);
//}).subscribe(
//    (ev) => {

//    }
//);
